import { catchError } from 'rxjs/operators';
import { of, OperatorFunction } from 'rxjs';
import { ErrorHandler, Injectable, inject } from '@angular/core';

/**
 * Swallows a failed HTTP call into `null` so an effect keeps running instead of tearing down
 * its action stream.
 *
 * The failure is still reported to the app's {@link ErrorHandler} (Rollbar in production,
 * `console.error` in dev): a silently discarded error used to strand whoever waited on the
 * store — e.g. a route resolver waiting for a value that could then never arrive — leaving a
 * blank page with nothing in the console to explain it.
 */
@Injectable({ providedIn: 'root' })
export class HttpUtils {
  private errorHandler = inject(ErrorHandler);

  catchAndPrintError<T>(): OperatorFunction<T, T | null> {
    return catchError((err) => {
      this.errorHandler.handleError(err);
      return of(null);
    }) as OperatorFunction<T, T | null>;
  }
}
